import * as React from "react";
import { MenuItem } from "../MobileMenu/MobileMenu.types";
import MobileMenu from "../MobileMenu/MobileMenu";
import { SiteFunctions } from "./SiteFunctions";
import { ISelectListItem } from "./ISelectListItem";
import { SimpleMobileMenu } from "../SimpleMobileMenu/SimpleMobileMenu";
import { SimpleMobileMenuFullNode } from "../SimpleMobileMenu/SimpleMobileMenuFullNode";

export interface ISiteMenuProps {
  minorityLanguage?: string;
  easyread?: string;
  signlanguage?: string;
  translatedStartpage?: string;
  translatedstartpageText?: string;
  menuIsOpen: boolean;
  menuId: string;
  currentPageId: number;
  isStartPage: boolean;
  treeNodes: MenuItem;
  siteMapUrl: string;
  minorityLanguages: ISelectListItem[];
  translatedItems: ISelectListItem[];
  translatedStartPageItems: ISelectListItem[];
  startPageid: number;
  signlanguageText: string;
  easyreadText: string;
  language: string;
  isCampaignPage?: boolean;
  highlightCurrentPage?: boolean;
  hideHeaderOnStartPage?: boolean;
  useSimpleMobileMenu?: boolean;
  currentPageAncestorsIds?: number[];
  ariaLabelBackInMenu?: string;
  useSimpleMobileFullNode?: boolean;
}

export interface ISiteMenuState {}

/**
 * Renders [[MobileMenu]] amd [[SiteFunctions]].
 */
export class SiteMenu extends React.Component<ISiteMenuProps, ISiteMenuState> {
  constructor(props: ISiteMenuProps) {
    super(props);
    this.state = {};
  }

  static defaultProps = {
    isCampaignPage: false,
  };

  render(): JSX.Element {
    return (
      <div
        aria-hidden={!this.props.menuIsOpen}
        className={`site-menu ${
          this.props.menuIsOpen ? "site-menu--open" : ""
        }`}
        id={this.props.menuId}
      >
        {this.props.useSimpleMobileMenu ? (
          this.props.useSimpleMobileFullNode ? (
            // Render FullNodeSimpleMobileMenu when both conditions are true
            <SimpleMobileMenuFullNode
              currentPageId={this.props.currentPageId}
              isStartPage={this.props.isStartPage}
              treeNodes={this.props.treeNodes}
              startPageId={this.props.startPageid}
              language={this.props.language}
              currentPageAncestorsIds={this.props.currentPageAncestorsIds}
            />
          ) : (
            // Render SimpleMobileMenu when useSimpleMobileMenu is true but useFullNodeSimpleMobileMenu is false
            <SimpleMobileMenu
              currentPageId={this.props.currentPageId}
              isStartPage={this.props.isStartPage}
              treeNodes={this.props.treeNodes}
              startPageId={this.props.startPageid}
              language={this.props.language}
              currentPageAncestorsIds={this.props.currentPageAncestorsIds}
              isCampaignPage={this.props.isCampaignPage}
            />
          )
        ) : (
          // Render MobileMenu when useSimpleMobileMenu is false
          <MobileMenu
            language={this.props.language}
            currentPageId={this.props.currentPageId}
            isStartPage={this.props.isStartPage}
            treeNodes={this.props.treeNodes}
            startPageId={this.props.startPageid}
            highlightCurrentPage={this.props.highlightCurrentPage}
            hideHeaderOnStartPage={this.props.hideHeaderOnStartPage}
            ariaLabelBackInMenu={this.props.ariaLabelBackInMenu}
          />
        )}
        <SiteFunctions
          siteMapUrl={this.props.siteMapUrl}
          minorityLanguages={this.props.minorityLanguages}
          translatedItems={this.props.translatedItems}
          translatedStartPageItems={this.props.translatedStartPageItems}
          minorityLanguage={this.props.minorityLanguage}
          easyread={this.props.easyread}
          signlanguage={this.props.signlanguage}
          translatedStartpage={this.props.translatedStartpage}
          translatedstartpageText={this.props.translatedstartpageText}
          signlanguageText={this.props.signlanguageText}
          easyreadText={this.props.easyreadText}
        />
      </div>
    );
  }
}
